<template>
  <div v-show="props.show" class="vfm vfm-inset">
    <div class="vfm-overlay vfm-inset" @click="handleClose"></div>
    <div class="vfm-content">
      <slot></slot>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from "vue";

const props = defineProps({
  closeOnClickOverlay: {
    type: Boolean,
    default: true
  },
  show: {
    type: Boolean,
    default: false
  }
});
watch(
  () => props.show,
  nv => {
    if (nv) {
      document.body.style.height = "100vh";
      document.body.style.overflow = "";
    } else {
      document.body.style.height = "";
      document.body.style.overflow = "";
    }
  }
);
const emit = defineEmits(["onclose"]);
function handleClose() {
  console.log("发送关闭.........")
  if (props.closeOnClickOverlay) {
    console.log("发送关闭.........")
    emit("onclose");
  }
}
</script>
<style lang="scss" scoped>
.vfm {
  position: fixed;
  inset: 0;
  max-width: 540px;
  margin: 0 auto;
  z-index: 9999;
  .vfm-overlay {
    position: absolute;
    inset: 0;
    background: rgba(48, 47, 47, 0.6) !important;
    backdrop-filter: blur(10px) !important;
    z-index: 1;
    cursor: pointer;
  }
}

.vfm-content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 540px;
  height: 100%;
  pointer-events: none;
}
.vfm-content > * {
  pointer-events: auto;
}
.vfm-inset{
  top:0;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>